import React, {useRef} from "react";
import {ValidatorForm} from "react-form-validator-core";
import ContentBox from "./ContentBox";
import Button from "@material-ui/core/Button";
import {GenerateInputs} from "./GenericInputField";
import {apiPost} from "../api";
import snackbar from "../snackbar";
import {Typography} from "@material-ui/core";
import {useCurrentState} from "../globalState";

function AccountSettings(props) {

    const inputRef = useRef(null);
    let [user, setUser] = useCurrentState("user");

    let inputs = GenerateInputs({
        email: {
            label: 'E-mail',
            type: 'email',
            help: 'you will have to confirm your account again if you change the e-mail.',
            defaultValue: user.email,
            validators: ['required', 'isEmail'],
            errorMessages: ['this field is required', 'email is not valid']
        },
        name: {
            defaultValue: user.name,
            label: 'Name'
        },
        password: {
            label: 'Password',
            type: 'password'
        },
        current_password: {
            label: 'Current Password',
            type: 'password'
        }
    });

    let submit = async () => {
        if (inputs.password.value && !inputs.current_password.value) {
            inputs.current_password.setError("please enter your current password");
            return;
        }
        inputs.disableAll(true);
        try {
            let res = await apiPost("update_user", inputs.toData());
            snackbar("Saved.");
            setUser(res.data);
            inputs.password.setValue("");
            inputs.current_password.setValue("");
        } catch (e) {
            snackbar(e.response.data.message);
        } finally {
            inputs.disableAll(false)
        }
    };

    return <div>
        <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
            <ContentBox
                actions={<Button disabled={inputs.email.disabled} type={"submit"}>Save</Button>}>
                <div>
                    <Typography variant={"h6"}>Details</Typography>
                    <div>
                        {inputs.name.field}
                    </div>
                    <div>
                        {inputs.email.field}
                    </div>
                    <br/>
                    <Typography variant={"h6"}>Change Password</Typography>
                    <div>
                        {inputs.current_password.field}
                    </div>
                    <div>
                        {inputs.password.field}
                    </div>
                </div>
            </ContentBox>
        </ValidatorForm>
    </div>;

}


export default AccountSettings;